import SwishError from './SwishError';

export default class ConflictError extends SwishError {
  isConflictError() { return true; }
}
